import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import 'brace';
import 'brace/mode/json';
import 'brace/mode/text';
import 'brace/theme/github';
import { CustomAttributesService } from '../../services/customAttributes/customAttributesService';
import { take } from 'rxjs';
import { CustomAttributeSection } from '../../entities/customAttributes/customAttributes';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { EditDialogService } from '../editDialog/editDialogService';
import { CustomAttributeSectionDialogComponent } from '../custom-attribute-section-dialog/custom-attribute-section-dialog.component';
import { ToastService } from '../../services/toast/toast.service';
import { ConfirmDialogService } from '../confirmDialog/confirmDialogService';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogEventType, ConfirmDialogSeverity } from '../confirmDialog/confirmDialogComponent';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'app-custom-attributes',
  templateUrl: './custom-attributes.component.html',
  styleUrls: ['./custom-attributes.component.scss']
})
export class CustomAttributesComponent {

  dialogRef: DynamicDialogRef | undefined;

  public entityTypes = [{
    id: 'Order',
    name: 'coreModuleModule.customAttributesComponent.entityType.order'
  }, {
    id: 'Resource',
    name: 'coreModuleModule.customAttributesComponent.entityType.resource'
  }, {
    id: 'ResourceAssignment',
    name: 'coreModuleModule.customAttributesComponent.entityType.resourceAssignment'
  }, {
    id: 'Contact',
    name: 'coreModuleModule.customAttributesComponent.entityType.contact'
  }]
  public selectedEntityType: any;
  public customAttributeSections: CustomAttributeSection[] = [];

  constructor(
    private apollo: Apollo,
    @Inject('env') public environment: any,
    public dialogService: EditDialogService,
    private customAttributesService: CustomAttributesService,
    private confirmDialogService: ConfirmDialogService,
    private translate: TranslateService,
    private toastService: ToastService,
    private loadingService: LoadingService
  ) {
  }

  addCustomAttributeSection(): void {
    // we need:
    // - the selected entity type
    // - the next free index for the custom attribute section
    let nextIndex = this.customAttributesService.getNextCustomAttributeSectionIndex(this.customAttributeSections);
    this.dialogRef = this.dialogService.open(CustomAttributeSectionDialogComponent, {
      header: 'coreModuleModule.customAttributeSectionDialogComponent.addCustomAttributeSectionDialogHeader',
      data: {
        entityType: this.selectedEntityType,
        nextIndex: nextIndex
      }
    });
    this.dialogRef.onClose.subscribe((result) => {
      // result is true or false, indiciating if it should refetch
      if (result) {
        this.loadCustomAttributeSections()
        this.toastService.addToastWithMessage('coreModuleModule.customAttributeSectionDialogComponent.customAttributeSectionCreatedToastMessage');
      }
    });
  }



  loadCustomAttributeSections(): void {
    this.customAttributesService.getCustomAttributeSections(this.selectedEntityType.id).pipe(
      take(1)
    ).subscribe((customAttributeSections) => {
      this.customAttributeSections = customAttributeSections;
      this.loadingService.setLoading(false);
      // Here you can handle the custom attribute sections for the selected entity type
      // For example, you might want to filter them based on the selected entity type
    })
  }

  refetchEvents(): void {
    // this.dataSource.loadEvents({
    //   pageNumber: this.pageNumber,
    //   pageSize: this.pageSize,
    //   sortProperty: this.sortProperty ? this.sortProperty : this.defaultSortProperty,
    //   sortDirection: this.sortDirection ? this.sortDirection : this.defaultSortDirection,
    // });
  }

}
